import { Input } from 'antd';
import React from 'react';

const TextAreaComponent = (props) => {
  const handleChange = (e) => {
    const value = typeof props.onChange === 'function' ? e : e.target.value;
    props.onChange(value);
  };

  return (
    <Input.TextArea
      maxLength={2650}
      {...props}
      onChange={handleChange}
    />
  );
};

export default TextAreaComponent;